/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input} from '@angular/core';

import template from './release-note-card.component.html';
import {SIMPLE_PAGE_IMPORTS} from './simple-page-imports';

@Component({
  standalone: true,
  imports: SIMPLE_PAGE_IMPORTS,
  selector: 'adn-release-note-card',
  template
})
export class ReleaseNoteCardComponent {
  @Input() note: any;
  @Input() singular = false;
  @Input() target = '';
}
